import { gql } from '@apollo/client';

export const GET_USER_INTERACTIONS = gql`
  query GetUserInteractions($page: String!, $action: String!) {
    vm {
      hasUserInteraction(page: $page, action: $action)
    }
  }
`;
